import {useStructureConfig} from "@/context/StructureConfigProvider";

type Props = {
    recordingId: string;
};

/**
 * Creates an audio player for a recording.
 * Although [MediaPlayer] exists, [RecordingPlayer] must have a separate component due
 * to its dependency on [useStructureConfig] and the nature of how this component is used.
 *
 * @param recordingId - The id of the recording we wish to create a player for
 * */
const RecordingPlayer = (props: Props) => {
    const structureConfig = useStructureConfig();
    return (
        <div>
            {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
            <audio controls preload="metadata" src={`${structureConfig.chattoUrl}download/${props.recordingId}`} />
        </div>
    );
};

export default RecordingPlayer;
